var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#BE1E2D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6523 28.5208L35.0366 24.0898L38.5814 19.7474C38.7753 19.5099 38.8975 19.222 38.9336 18.9175C38.9697 18.613 38.9182 18.3045 38.7853 18.0282C38.6506 17.7185 38.4272 17.4556 38.1433 17.2727C37.8595 17.0897 37.5278 16.9949 37.1901 17.0002H9.718C9.49571 16.9967 9.27491 17.037 9.0682 17.1188C8.86149 17.2007 8.67293 17.3224 8.51328 17.4771C8.35363 17.6318 8.22602 17.8165 8.13774 18.0205C8.04946 18.2245 8.00224 18.444 7.99878 18.6663V29.5222C8.00809 29.9696 8.19419 30.395 8.51636 30.7056C8.83854 31.0162 9.27058 31.1865 9.718 31.1794H37.2876C37.614 31.1848 37.9351 31.0968 38.213 30.9256C38.491 30.7544 38.7141 30.5073 38.8562 30.2134C38.9837 29.9404 39.0322 29.6371 38.9962 29.338C38.9601 29.0388 38.841 28.7557 38.6523 28.5208ZM9.77117 29.407V18.7726H37.0483L32.7591 24.0278L37.1103 29.407H9.77117Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3201 25.2856L13.4311 21.4307H12.4297V26.9074H13.4311V23.0613L16.3201 26.9074H17.3126V21.4307H16.3201V25.2856Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7925 26.9074H22.9222V26.0034H19.7939V24.5767H22.6209V23.6639H19.7939V22.3434H22.9222V21.4307H18.7925V26.9074Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7285 25.3565L28.4347 21.4307H27.3535L26.0508 25.3565L24.881 21.4307H23.791L25.528 26.9074H26.5116L27.8941 22.8397L29.2677 26.9074H30.2691L31.9972 21.4307H30.9072L29.7285 25.3565Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIcon);
export default __webpack_public_path__ + "static/media/NewIcon.b7e978d21e709b9ca62edbbfb022b379.svg";
export { ForwardRef as ReactComponent };